<div class="favorites-container">
  <!-- Displays favorites grouped by parent category (Highest in the hierarchy) -->
  <div class="grouped-favorites">
    @for (group of groupedFavorites(); track group.parent?.title) {
      <div class="category-group">
        <h2 class="category-title">{{ group.parent.title }}</h2>
        @if (group.parent.description) {
          <p class="category-description">{{ group.parent.description }}</p>
        }

        <div class="card-container">
          @for (favorite of group.favorites; track favorite.title) {
            <app-card-menu
              [cardItem]="favorite"
              (parentClicked)="onCardClicked($event)"
              (toggleFavorite)="emitToggleFavorite(favorite)"
            />
          }
        </div>
      </div>
    }

    @if (groupedFavorites().length === 0) {
      <app-no-favorites />
    }
  </div>
</div>
